var config = {}
config.debug = false

if (process.env.NODE_ENV === 'production') {
  config.base_url = 'https://api.xinc.io'
} else {
  config.debug = true
  config.base_url = 'http://localhost:5000'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js